const CONTACT_API_URL =
  process.env.REACT_APP_CONTACT_API_URL || "https://fungenberg.de/api/v1/SMTPcontact";

function extractErrorMessage(data, response) {
  if (typeof data === "string" && data.trim()) return data;
  if (data?.error && typeof data.error === "string") return data.error;
  if (data?.message && typeof data.message === "string") return data.message;
  if (data?.detail && typeof data.detail === "string") return data.detail;

  if (response.status >= 500) {
    return "Serverfehler beim Senden. Bitte versuchen Sie es in wenigen Minuten erneut.";
  }
  if (response.status >= 400) {
    return "Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.";
  }
  return "Senden fehlgeschlagen";
}

export async function sendContactMessage(payload) {
  const response = await fetch(CONTACT_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.ok) {
    throw new Error(extractErrorMessage(data, response));
  }

  return data;
}
